import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const SectionWrapper = styled.div`
  display: flex;
  flex-flow: wrap;
  gap: 1.5rem;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 50%;
  }
`;

export const CardContainers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  margin-left: 0;
  height: calc(50% - 0.75rem);

  > li {
    width: 100%;
    max-width: unset;
    padding: 1.5rem 2rem;
    border-radius: 0.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    > li {
      padding: 2rem 2rem;
      width: calc(50% - 0.75rem);
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;
    > li {
      padding: 2rem 1rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    flex-direction: row;
    > li {
      padding: 3rem 2rem;
      width: calc(50% - 0.75rem);
    }
  }
`;
